export const ALL_ITEM_AUTOMOTIVE = [
    {
      categry: "automotic",
      itemList: [
        {
          itemSelected: "tesoro",
          itemName: "Tesoro",
          itemDescription:
            "Tesoro is a car key box designed to protect your key and impress the receiver. We use a variety of materials to enhance both interior and exterior.",
            itemDescriptionList: [
              "Made in Thailand Craftsmanship",
              "Variety of World Class Materials",
              "Professional Consultation",
              "Fast Delivery",
            ],
          itemDesktopBig: [
            "/images/listItem/customizedProjects/Automotive/Desktop/Tesoro/700x700px/lussopack-automotive-tesoro-01.webp",          
            "/images/listItem/customizedProjects/Automotive/Desktop/Tesoro/700x700px/lussopack-automotive-tesoro-02.webp",                
          ],
          itemDesktopSmall: [
            "/images/listItem/customizedProjects/Automotive/Desktop/Tesoro/130x130px/lussopack-automotive-tesoro-01.webp",
            "/images/listItem/customizedProjects/Automotive/Desktop/Tesoro/130x130px/lussopack-automotive-tesoro-02.webp",
          ],
          itemMobileBig: [
            "/images/listItem/customizedProjects/Automotive/Mobile/Tesoro/335x335px/lussopack-automotive-tesoro-01.webp",
            "/images/listItem/customizedProjects/Automotive/Mobile/Tesoro/335x335px/lussopack-automotive-tesoro-02.webp",
          ],
          itemMobileSmall: [
            "/images/listItem/customizedProjects/Automotive/Mobile/Tesoro/100x100px/lussopack-automotive-tesoro-01.webp",
            "/images/listItem/customizedProjects/Automotive/Mobile/Tesoro/100x100px/lussopack-automotive-tesoro-02.webp",
          ],
        },
        {
          itemSelected: "zucchero",
          itemName: "Zucchero",
          itemDescription:
            "Zucchero is a car key box designed to protect your key and impress the receiver. We use a variety of materials to enhance both interior and exterior.",
            itemDescriptionList: [
              "Made in Thailand Craftsmanship",
              "Variety of World Class Materials",
              "Professional Consultation",
              "Fast Delivery",
            ],
          itemDesktopBig: [
            "/images/listItem/customizedProjects/Automotive/Desktop/Zucchero/700x700px/lussopack-automotive-zucchero-01.webp",          
            "/images/listItem/customizedProjects/Automotive/Desktop/Zucchero/700x700px/lussopack-automotive-zucchero-02.webp",                
          ],
          itemDesktopSmall: [
            "/images/listItem/customizedProjects/Automotive/Desktop/Zucchero/130x130px/lussopack-automotive-zucchero-01.webp",
            "/images/listItem/customizedProjects/Automotive/Desktop/Zucchero/130x130px/lussopack-automotive-zucchero-02.webp",
          ],
          itemMobileBig: [
            "/images/listItem/customizedProjects/Automotive/Mobile/Zucchero/335x335px/lussopack-automotive-zucchero-01.webp",
            "/images/listItem/customizedProjects/Automotive/Mobile/Zucchero/335x335px/lussopack-automotive-zucchero-02.webp",
          ],
          itemMobileSmall: [
            "/images/listItem/customizedProjects/Automotive/Mobile/Zucchero/100x100px/lussopack-automotive-zucchero-01.webp",
            "/images/listItem/customizedProjects/Automotive/Mobile/Zucchero/100x100px/lussopack-automotive-zucchero-02.webp",
          ],
        },
      ],
    },
  ];
  